module.exports = __webpack_public_path__ + "media/2.2_super_adjectives_tarjeta_avatar_woman_cf1.03638bd6.wav";